/**
 * Render the final JSX of MenuTrigger
 *
 * Only renders children
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderDialogTrigger_unstable", {
    enumerable: true,
    get: function() {
        return renderDialogTrigger_unstable;
    }
});
const renderDialogTrigger_unstable = (state)=>state.children;
